module.exports = __webpack_public_path__ + "static/img/popover_iconh5_03_zh.7e83785.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popover_iconh5_03_zh.png
// module id = xNEV
// module chunks = 34